import React, { Suspense } from "react";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { Section } from "../../Common/layout/Section";
import { OrderManagement } from "./Orders";
import { Switch } from "react-router-dom";
import { Permissions } from "../../../util/Permissions";

const OrderManagementPages = () => {
    return <>
    <AsideMenu>
        <UserGroupMenu destination="/orders" />
    </AsideMenu>
    <Section>
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <ContentRoute path="/orders/:userGroup" permission={Permissions.ORDERS} component={OrderManagement} />
            </Switch>
        </Suspense>
    </Section>
</>
};

export default OrderManagementPages;
